module.exports = __webpack_public_path__ + "media/question1_en_b.eb6bb653.wav";